export const AI_PROVIDER_LABELS = {
  gemini: "Gemini",
  openai: "OpenAI",
  anthropic: "Anthropic",
};

export const AI_PROVIDER_ORDER = ["gemini", "openai", "anthropic"];

export const DEFAULT_SPREADSHEET_MODEL_ID = "gemini-3.8-flash";
export const DEFAULT_WORKSPACE_PROVIDER = "gemini";

// Exactly the backend MODEL_CATALOG (BE #792): IDs, labels and credits mirror
// app/utils/llm_selection.py and MODEL_CREDIT_COSTS in app/utils/ai_billing.py.
// Older IDs are backend aliases only and are never offered here.
export const SPREADSHEET_AI_MODELS = [
  {
    id: "gemini-3.8-flash",
    label: "Gemini 3.8 Flash",
    provider: "gemini",
    credits: 3,
    description: "Default speed-and-cost-balanced option for enrichment workloads.",
    badges: ["Default"],
  },
  {
    id: "gemini-3.1-flash-lite",
    label: "Gemini 3.1 Flash Lite",
    provider: "gemini",
    credits: 3,
    description: "Budget Gemini option for lightweight, high-throughput runs.",
  },
  {
    id: "gemini-3.1-pro-preview",
    label: "Gemini 3.1 Pro",
    provider: "gemini",
    credits: 6,
    description: "Advanced Gemini option for deeper reasoning on hard prompts.",
    badges: ["Preview"],
  },
  {
    id: "gpt-6-astra",
    label: "GPT-6 Astra",
    provider: "openai",
    credits: 15,
    description: "Flagship OpenAI option for the most complex research prompts.",
  },
  {
    id: "gpt-6.1-sol",
    label: "GPT-6.1 Sol",
    provider: "openai",
    credits: 6,
    description: "Advanced OpenAI reasoning option for nuanced research and synthesis.",
  },
  {
    id: "gpt-6-sol",
    label: "GPT-6 Sol",
    provider: "openai",
    credits: 6,
    description: "Premium OpenAI option for balanced quality on research prompts.",
  },
  {
    id: "gpt-6-luna",
    label: "GPT-6 Luna",
    provider: "openai",
    credits: 3,
    description: "Low-cost OpenAI option for fast, lighter enrichment tasks.",
    badges: ["Recommended OpenAI"],
  },
  {
    id: "claude-fable-5-1",
    label: "Claude Fable 5.1",
    provider: "anthropic",
    credits: 15,
    description: "Flagship Anthropic option for the most demanding reasoning tasks.",
  },
  {
    id: "claude-opus-5-5",
    label: "Claude Opus 5.5",
    provider: "anthropic",
    credits: 8,
    description: "Advanced Anthropic option for demanding reasoning tasks.",
  },
  {
    id: "claude-sonnet-5-5",
    label: "Claude Sonnet 5.5",
    provider: "anthropic",
    credits: 6,
    description: "Premium Anthropic option for careful reasoning and polished summaries.",
    badges: ["Recommended Anthropic"],
  },
  {
    id: "claude-haiku-4-5-20251001",
    label: "Claude Haiku 4.5",
    provider: "anthropic",
    credits: 3,
    description: "Lower-cost Anthropic option for faster, lighter prompts.",
  },
];

// Provider-only flows bill the backend PROVIDER_DEFAULT_MODELS.
export const WORKSPACE_AI_PROVIDERS = [
  {
    id: "gemini",
    label: "Gemini",
    hiddenModelId: "gemini-3.8-flash",
    hiddenModelLabel: "Gemini 3.8 Flash",
    credits: 3,
    description: "Default speed-and-cost-balanced option for workspace enrichment.",
  },
  {
    id: "openai",
    label: "OpenAI",
    hiddenModelId: "gpt-6-luna",
    hiddenModelLabel: "GPT-6 Luna",
    credits: 3,
    description: "Low-cost OpenAI option for fast, lighter enrichment tasks.",
  },
  {
    id: "anthropic",
    label: "Anthropic",
    hiddenModelId: "claude-sonnet-5-5",
    hiddenModelLabel: "Claude Sonnet 5.5",
    credits: 6,
    description: "Premium Anthropic option for careful reasoning and polished summaries.",
  },
];

export const getSpreadsheetModelById = (modelId) =>
  SPREADSHEET_AI_MODELS.find((model) => model.id === modelId) ||
  SPREADSHEET_AI_MODELS.find((model) => model.id === DEFAULT_SPREADSHEET_MODEL_ID) ||
  SPREADSHEET_AI_MODELS[0];

export const getWorkspaceProviderById = (providerId) =>
  WORKSPACE_AI_PROVIDERS.find((provider) => provider.id === providerId) ||
  WORKSPACE_AI_PROVIDERS.find((provider) => provider.id === DEFAULT_WORKSPACE_PROVIDER) ||
  WORKSPACE_AI_PROVIDERS[0];
